const SET_PROFESSIONS = (state, professions) => {
    state.items = professions;
};

export default {
    SET_PROFESSIONS
};
